import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Navigation = ({ menuOpen, toggleMenu, closeMenu, navItems }) => {
  const [activeNav, setActiveNav] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToElement = (elementId, offset = 100) => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
      return true;
    }
    return false;
  };

  const handleNavClick = (e, href) => {
    e.preventDefault();
    closeMenu();

    // Якорь на главной странице (/#news, /#about, /#contacts)
    if (href.startsWith('/#')) {
      const targetId = href.slice(2);
      if (location.pathname !== '/') {
        // Переходим на главную, затем прокручиваем
        navigate('/');
        // Даём время на загрузку главной страницы
        setTimeout(() => {
          scrollToElement(targetId);
        }, 300);
      } else {
        // Уже на главной – сразу прокручиваем
        scrollToElement(targetId);
      }
    }
    // Обычный маршрут (например, /gallery, /documents)
    else if (href.startsWith('/')) {
      navigate(href);
    }
    // Старые якоря без слеша (на всякий случай)
    else if (href.startsWith('#')) {
      const targetId = href.slice(1);
      scrollToElement(targetId);
    }
  };

  // Определение активного пункта при скролле
  useEffect(() => {
    const handleScroll = () => {
      const sections = navItems
        .filter(item => item.href.startsWith('/#'))
        .map(item => item.href.slice(2));
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveNav(section);
            return;
          }
        }
      }
      setActiveNav('');
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [navItems]);

  const isActive = (href) => {
    if (href === location.pathname) return true;
    if (href.startsWith('/#')) {
      return location.pathname === '/' && activeNav === href.slice(2);
    }
    return false;
  };

  return (
    <nav>
      <div className="container nav-container">
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          {navItems.map(item => (
            <li key={item.id}>
              <a
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={isActive(item.href) ? 'active' : ''}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Меню">
          <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;